import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { YupmaUiKitModule } from '@yupma/ui-kit';
import { RouterModule } from '@angular/router';
import { NumberInputComponent, ConfettiComponent, PhoneInputComponent, BottombarComponent, NoteComponent, TopbarComponent, SidebarComponent, SidebarFeedbackComponent, EmailInputComponent, CheckboxInputComponent, DateAndTimePickerInputComponent, DatePickerInputComponent, DropdownInputComponent, MultiSelectDropdownInputComponent, TextareaInputComponent, TextInputComponent, UserInputComponent, EmailEditPopoverComponent, SingleDateAndTimePickerInputComponent, SingleEmailInputComponent, SinglePhoneInputComponent, PhoneEditPopoverComponent, FieldSelectionDropdownComponent, GlobalOverlaysComponent, CreateContactDrawerComponent, CustomizeEntityViewDrawerComponent, SkeletonLoaderComponent, ContactsListItemComponent, TasksListItemComponent, DeleteDialogComponent, EditFieldOptionCustomizationComponent, GlobalInputComponent, CreateActivityModalComponent, RichTextareaInputComponent, HomeTopbarComponent, FilterComponent, FilterConditionBarComponent, EntityFilterModalComponent, FilterConditionInputComponent, UserAvatarComponent, EntitySortModalComponent } from './components';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        YupmaUiKitModule,
        NgOptimizedImage,
        RouterModule,
        DragDropModule,
    ],
    providers: [],
    declarations: [
        BottombarComponent,
        TopbarComponent,
        HomeTopbarComponent,
        NoteComponent,
        SidebarComponent,
        SidebarFeedbackComponent,

        GlobalInputComponent,
        EmailInputComponent,
        PhoneInputComponent,
        TextInputComponent,
        TextareaInputComponent,
        RichTextareaInputComponent,
        NumberInputComponent,
        DropdownInputComponent,
        MultiSelectDropdownInputComponent,
        CheckboxInputComponent,
        DatePickerInputComponent,
        UserInputComponent,
        DateAndTimePickerInputComponent,
        SingleEmailInputComponent,
        SinglePhoneInputComponent,
        SingleDateAndTimePickerInputComponent,
        EmailEditPopoverComponent,
        PhoneEditPopoverComponent,
        FieldSelectionDropdownComponent,
        GlobalOverlaysComponent,
        CreateContactDrawerComponent,
        CustomizeEntityViewDrawerComponent,
        SkeletonLoaderComponent,
        ConfettiComponent,
        TasksListItemComponent,
        ContactsListItemComponent,
        DeleteDialogComponent,
        EditFieldOptionCustomizationComponent,
        CreateActivityModalComponent,
        EntityFilterModalComponent,
        FilterComponent,
        FilterConditionBarComponent,
        FilterConditionInputComponent,
        UserAvatarComponent,
        EntitySortModalComponent,
    ],
    exports: [
        CommonModule,
        YupmaUiKitModule,
        NgOptimizedImage,

        BottombarComponent,
        TopbarComponent,
        HomeTopbarComponent,
        NoteComponent,
        SidebarComponent,
        SidebarFeedbackComponent,

        GlobalInputComponent,
        EmailInputComponent,
        PhoneInputComponent,
        TextInputComponent,
        TextareaInputComponent,
        RichTextareaInputComponent,
        NumberInputComponent,
        DropdownInputComponent,
        MultiSelectDropdownInputComponent,
        CheckboxInputComponent,
        DatePickerInputComponent,
        UserInputComponent,
        DateAndTimePickerInputComponent,
        SingleEmailInputComponent,
        SinglePhoneInputComponent,
        SingleDateAndTimePickerInputComponent,
        EmailEditPopoverComponent,
        PhoneEditPopoverComponent,
        FieldSelectionDropdownComponent,
        GlobalOverlaysComponent,
        CreateContactDrawerComponent,
        CustomizeEntityViewDrawerComponent,
        SkeletonLoaderComponent,
        ConfettiComponent,
        TasksListItemComponent,
        ContactsListItemComponent,
        DeleteDialogComponent,
        EditFieldOptionCustomizationComponent,
        CreateActivityModalComponent,
        EntityFilterModalComponent,
        FilterComponent,
        FilterConditionBarComponent,
        FilterConditionInputComponent,
        UserAvatarComponent,
        EntitySortModalComponent,
    ],
})

export class ClientCommonModule {
}
